import { injectable } from "inversify";
import { IGameCanvasStylingService } from "./IGameCanvasStylingService";

@injectable()
export default class GameCanvasStylingService implements IGameCanvasStylingService {
    public setCursorStyle(cursorStyle: string): void {
        const canvas = this.getGameCanvas();
        if (!canvas) {
            console.warn(`[${GameCanvasStylingService.name}] Unable to find game canvas element to set cursor style.`);
            return;
        }

        if (canvas.style.cursor === cursorStyle) {
            return;
        }

        canvas.style.cursor = cursorStyle;
    }

    private getGameCanvas(): HTMLCanvasElement | null {
        return document.getElementById('unity-canvas') as HTMLCanvasElement || document.getElementsByTagName('canvas')[0];
    }
}